"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var VFEgoCamera = (function (_super) {
    __extends(VFEgoCamera, _super);
    function VFEgoCamera(name, position, scene) {
        var _this = _super.call(this, name, position, scene) || this;
        _this.startAngle = 0;
        _this.minAngle = -1;
        _this.hasLimits = false;
        _this.maxAngle = -1;
        return _this;
    }
    VFEgoCamera.prototype.Vector3Rotate = function (v, q) {
        var matrix = new babylonjs_1.Matrix();
        q.toRotationMatrix(matrix);
        var rotatedvect = babylonjs_1.Vector3.TransformCoordinates(v, matrix);
        return rotatedvect;
    };
    VFEgoCamera.prototype.moveTo = function (position, rotation, onAnimationEnd) {
        var _this = this;
        if (VFEgoCamera.SkipsNextEgoTransition) {
            this.rotationQuaternion = rotation;
            this.position = position;
            this.setTarget(this.getFrontPosition(1));
            if (onAnimationEnd) {
                onAnimationEnd();
            }
            VFEgoCamera.SkipsNextEgoTransition = false;
            return;
        }
        if (rotation) {
            babylonjs_1.Animation.CreateAndStartAnimation("at5", this, "rotationQuaternion", 125, 120, this.rotationQuaternion, rotation, 0, VFEgoCamera.EASE_MODE);
        }
        babylonjs_1.Animation.CreateAndStartAnimation("at5", this, "position", 125, 120, this.position, position, 0, VFEgoCamera.EASE_MODE, function () {
            _this.setTarget(_this.getFrontPosition(1));
            if (onAnimationEnd) {
                onAnimationEnd();
            }
        });
    };
    VFEgoCamera.prototype.setEgoLimits = function (startAngle, minAngle, maxAngle) {
        this.noRotationConstraint = false;
        this.hasLimits = true;
        this.startAngle = startAngle;
        if (this.startAngle !== -1) {
            this.rotation.y = babylonjs_1.Tools.ToRadians(this.startAngle);
        }
        this.minAngle = minAngle;
        this.maxAngle = maxAngle;
    };
    VFEgoCamera.prototype.removeEgoLimits = function () {
        this.noRotationConstraint = true;
        this.hasLimits = false;
    };
    VFEgoCamera.prototype.applyLimits = function () {
        if (this.hasLimits === true) {
            this.rotation.y = babylonjs_1.Tools.ToRadians(VFEgoCamera.clamp(babylonjs_1.Tools.ToDegrees(this.rotation.y), this.minAngle, this.maxAngle));
        }
    };
    VFEgoCamera.clamp = function (num, min, max) {
        return num <= min ? min : num >= max ? max : num;
    };
    VFEgoCamera.EASE_MODE = new babylonjs_1.CubicEase();
    VFEgoCamera.SkipsNextEgoTransition = false;
    return VFEgoCamera;
}(babylonjs_1.UniversalCamera));
exports.default = VFEgoCamera;
